import localstorage from './localstorage';
import sessionstorage from './sessionstorage';

const STR_TOKEN = 'STR_TOKEN';
const STR_MERCHANTNO = 'STR_MERCHANTNO';
const STR_MOBILE = 'STR_MOBILE';
const STR_RECENTLY = 'STR_RECENTLY';
const STR_FIRSTLOGIN = 'STR_FIRSTLOGIN';
const STR_RECORD_IDS = 'STR_RECORD_IDS';
const STR_HOMECHARTEYE = 'STR_HOMECHARTEYE';
const STR_SUBJECT_INFO = 'STR_SUBJECT_INFO';

const storage = {
  setToken(content) {
    localstorage.setStore(STR_TOKEN, content);
  },
  getToken() {
    return localstorage.getStore(STR_TOKEN);
  },
  setMerchantNo(content) {
    localstorage.setStore(STR_MERCHANTNO, content);
  },
  getMerchantNo() {
    return localstorage.getStore(STR_MERCHANTNO);
  },
  setMobile(content) {
    localstorage.setStore(STR_MOBILE, content);
  },
  getMobile() {
    return localstorage.getStore(STR_MOBILE);
  },
  setFirstLogin(content) {
    localstorage.setStore(STR_FIRSTLOGIN, content);
  },
  getFirstLogin() {
    if (localstorage.getStore(STR_FIRSTLOGIN) === null) {
      return true;
    } else {
      return JSON.parse(localstorage.getStore(STR_FIRSTLOGIN));
    }
  },
  setHomeChartEye(content) {
    localstorage.setStore(STR_HOMECHARTEYE, content);
  },
  getHomeChartEye() {
    return localstorage.getStore(STR_HOMECHARTEYE) === 'true';
  },
  setRecently(content) {
    localstorage.setStore(STR_RECENTLY, content);
  },
  getRecently() {
    return JSON.parse(localstorage.getStore(STR_RECENTLY) || '{}');
  },
  setRecordIds(content) {
    localstorage.setStore(STR_RECORD_IDS, content);
  },
  getRecordIds() {
    return JSON.parse(localstorage.getStore(STR_RECORD_IDS) || '{}');
  },
  setSubjectInfo(content) {
    sessionstorage.setStore(STR_SUBJECT_INFO, content);
  },
  getSubjectInfoFromCache() {
    return JSON.parse(sessionstorage.getStore(STR_SUBJECT_INFO) || '{}');
  }
};

export default storage;
